import AuthLoadingScreen from '../../components/AuthLoadingScreen/AuthLoadingScreen.component'

const AuthRedirect = (): JSX.Element => (
  <AuthLoadingScreen title="Redirecting…" />
)

export default AuthRedirect
